import { useGetProjectsQuery } from "../../../store/api/lumi/projects";
import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { ProjectCard } from "../ProjectCard";
import { Empty, Pagination } from "antd";
import { useIsFirstRender } from "../../../hooks/useFirstRender";

const PAGE_SIZE = 6;

export const ProjectsList = (props) => {
    const { searchQuery, sortBy, currentWorkspace } = props;

    const { data } = useGetProjectsQuery();
    const [workspaceProjects, setWorkspaceProjects] = useState([]);
    const isFirstRender = useIsFirstRender();

    const [pagination, setPagination] = useState({
        current: 1,
        minIndex: 0,
        maxIndex: PAGE_SIZE,
    });

    useEffect(() => {
        !isFirstRender &&
            setPagination({
                current: 1,
                minIndex: 0,
                maxIndex: PAGE_SIZE,
            });
    }, [currentWorkspace, isFirstRender, searchQuery]);

    useEffect(() => {
        if (data) {
            const filtered = data?.filter((el) => (
                el.workspace_id === currentWorkspace || currentWorkspace === 'loading'
            ));

            setWorkspaceProjects(filtered);
        }
    }, [currentWorkspace, data]);

    let filteredProjects = _.chain(workspaceProjects)
        .filter(
            (project) =>
                project.name &&
                project.name
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()) &&
                project.last_successful_build_time
        )
        .sortBy(sortBy.replace(" desc", ""))
        .value();

    if (sortBy.includes("desc")) {
        filteredProjects = filteredProjects.reverse();
    }

    const projects = useMemo(() => {
        return filteredProjects
            .slice(pagination.minIndex, pagination.maxIndex)
            .map((el) => <ProjectCard key={el.project_id} {...el} />);
    }, [filteredProjects, currentWorkspace]);

    const handleChangePagination = (page) => {
        setPagination({
            current: page,
            minIndex: (page - 1) * PAGE_SIZE,
            maxIndex: page * PAGE_SIZE,
        });
    };
    return (
        <div className="projects-content">
            {filteredProjects.length ? (
                <>
                    {projects}
                    <Pagination
                        defaultCurrent={pagination.current}
                        current={pagination.current}
                        onChange={handleChangePagination}
                        total={filteredProjects.length}
                        pageSize={PAGE_SIZE}
                        showSizeChanger={false}
                    />
                </>
            ) : (
                <Empty />
            )}
        </div>
    );
};
